import React from 'react'
import { useMutation } from '@apollo/client'
import { useToast } from '@winnin/winnin_ui.components.toast'

import refreshCreator from 'assets/images/png/refreshCreator.png'
import { useTranslate } from 'lib/tolgee'

import { REFRESH_CREATOR } from './query'
import './index.scss'

function RefreshCreatorImageButton({ id, provider }) {
  const { createToast } = useToast()
  const t = useTranslate()

  const [refreshCreatorThumb, { loading }] = useMutation(REFRESH_CREATOR, {
    onCompleted() {
      createToast({
        content: t({
          key: 'RefreshCreatorImageButton-createSuccessToast',
          defaultValue: 'The creator picture will be added to our database in a few minutes',
        }),
      })
    },
    onError(error) {
      console.error('RefreshCreatorImageButton @ REFRESH_CREATOR', error)
    },
  })

  function handleRefreshCreatorImage(e) {
    e.preventDefault()
    e.stopPropagation()

    refreshCreatorThumb({ variables: { data: { id, provider } } })
  }

  return (
    <button onClick={handleRefreshCreatorImage} disabled={loading} className="RefreshCreatorImageButton">
      <img src={refreshCreator} alt="refresh" loading="lazy" />
    </button>
  )
}

export default RefreshCreatorImageButton
